<div class="container">
  <h3>Stared Songs</h3>
  <div class="row">
    <div class="col-lg-6 offset-lg-3" *ngIf="likedSongList.length > 0">
      <div class="list" *ngFor="let song of likedSongList">
        <a class="list-group-item" style="cursor: pointer;">
          <img [src]="song.albumArt" [alt]="song.name" height="50px" />
          <span class="space"></span>
          <span class="info">
            {{ song.name }}
            <small class="text-muted"
              >({{
                song.artist.length > 20
                  ? song.artist.substring(0, 20) + "..."
                  : song.artist
              }})</small
            >
          </span>
          <span class="btn-space"></span>
          <button id="play" class="btn" (click)="onSelect(song)">
            <img src="../../assets/play-circle.svg" alt="" />
          </button>
        </a>
      </div>
    </div>
    <div class="col-md-6 offset-md-3" *ngIf="likedSongList.length == 0">
      <p>Playlist Empty!</p>
    </div>
  </div>
</div>
